import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { navRoutes, mpNavRoutes } from 'constant/nav-routes-plcp'
import * as ROUTES from 'constant/routes-plcp'
import Footer from 'view/component/footer'
import Navbar from 'js/view-plcp/component/navbar'
import PropTypes from 'prop-types'
import { Layout } from 'antd'
import { bindActionCreators } from 'redux'
import { authQlik } from 'action/auth'
import * as Components from './lazy-components'

const { Content } = Layout

const LoggedInRoutesPLCP = ({ user, authQlik }) => {
  const [mp, updateMp] = useState(false)

  useEffect(() => {
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const handleMessage = (event) => {
    const { data, origin } = event
    if (origin.includes('https://analytics.premierleague.com') && data) {
      localStorage.setItem('filterState', data.selections)
    }
  }

  useEffect(() => {
    if (window.location.href.includes('mp')) {
      authQlik()
      updateMp(true)
    }
  }, [])

  return (<div>
    <Navbar />
    <Footer plcp={true} />
    {getLayout(user, mp)}
  </div>
  )
}

const getLayout = (user, mp) => (
  <Layout className='bg-purple plcp-bg-height'>
    <Content>
      <Switch>
        {mp
        ? <> {mpNavRoutes.map(({ component, exact, href }, index) => (
          <Route
            component={Components[component]}
            exact={exact}
            key={index}
            path={href}
          />
        ))}
        <Route
          exact
          path='/mp'
          render={() => {
            return <Redirect to={ROUTES.HOME_MP} />
          }}
        />
        <Route
          exact
          path='/mp/undefined'
          render={() => {
            return <Redirect to={ROUTES.HOME_MP} />
          }}
        />
        </>
        : <> {navRoutes.map(({ component, exact, href }, index) => (
          <Route
            component={Components[component]}
            exact={exact}
            key={index}
            path={href}
          />
        ))}
        <Route
          exact
          path='/'
          render={() => {
            return <Redirect to={ROUTES.HOME} />
          }}
        /></>
        }
      </Switch>
    </Content>
  </Layout>)

LoggedInRoutesPLCP.propTypes = {
  authQlik: PropTypes.func,
  showFooter: PropTypes.bool,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({
  authQlik: bindActionCreators(authQlik, dispatch)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoggedInRoutesPLCP))
